import { render, staticRenderFns } from "./accountInfo.vue?vue&type=template&id=0b95d2ec&"
import script from "./accountInfo.vue?vue&type=script&lang=js&"
export * from "./accountInfo.vue?vue&type=script&lang=js&"
import style0 from "./accountInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports